/**
 * An entity is an id + a tag set + a component bag. All cross-component lookup
 * goes through `entity.get(MixtureClass)` — never through parallel maps.
 */
export class Entity {
    id;
    tags = new Set();
    components = new Map();
    constructor(id) {
        this.id = id;
    }
    add(component) {
        const type = component.constructor.type;
        if (!type)
            throw new Error(`component ${component.constructor.name} missing static type`);
        if (this.components.has(type)) {
            throw new Error(`entity ${this.id} already has component ${type}`);
        }
        component.entity = this;
        this.components.set(type, component);
        return component;
    }
    get(cls) {
        return this.components.get(cls.type);
    }
    getByType(type) {
        return this.components.get(type);
    }
    has(cls) {
        return this.components.has(cls.type);
    }
    remove(cls) {
        const c = this.components.get(cls.type);
        if (!c)
            return;
        c.dispose();
        c.entity = null;
        this.components.delete(cls.type);
    }
    *componentEntries() {
        yield* this.components.entries();
    }
    dispose() {
        for (const c of this.components.values()) {
            c.dispose();
            c.entity = null;
        }
        this.components.clear();
    }
}
